function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "rewards/power-builder-gold");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "0.00530232558 0 44.6563953 0 44.6563953 48 0.00530232558 48"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "0.00530232558 0 44.6563953 0 44.6563953 44.5217391 0.00530232558 44.5217391"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-5",
  points: "0.00530232558 0 44.6563953 0 44.6563953 44.5217391 0.00530232558 44.5217391"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Product",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-Rewards-1440",
  transform: "translate(-1006.000000, -297.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "rewards/power-builder-gold",
  transform: "translate(1006.000000, 297.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-26"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.3308837,48 L22.3308837,48 C10.0008837,48 0.00530232558,38.0333913 0.00530232558,25.7391304 L0.00530232558,4.17391304 C0.00530232558,1.86886957 1.87960465,0 4.19134884,0 L40.4704186,0 C42.7821628,0 44.6564651,1.86886957 44.6564651,4.17391304 L44.6564651,25.7391304 C44.6564651,38.0333913 34.6608837,48 22.3308837,48",
  id: "Fill-1",
  fill: "#AD8D07",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.3308837,44.5217391 L22.3308837,44.5217391 C10.0008837,44.5217391 0.00530232558,34.5551304 0.00530232558,22.2608696 L0.00530232558,4.17391304 C0.00530232558,1.86886957 1.87960465,0 4.19134884,0 L40.4704186,0 C42.7821628,0 44.6564651,1.86886957 44.6564651,4.17391304 L44.6564651,22.2608696 C44.6564651,34.5551304 34.6608837,44.5217391 22.3308837,44.5217391",
  id: "Fill-4",
  fill: "#FFDC4A",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-6",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.4704186,0 L4.19134884,0 C1.87960465,0 0.00530232558,1.86886957 0.00530232558,4.17391304 L0.00530232558,22.2608696 C0.00530232558,34.5551304 10.0008837,44.5217391 22.3308837,44.5217391 C34.6608837,44.5217391 44.6564651,34.5551304 44.6564651,22.2608696 L44.6564651,4.17391304 C44.6564651,1.86886957 42.7821628,0 40.4704186,0 M40.4704186,4.17391304 L40.4704186,22.2608696 C40.4704186,32.234087 32.333093,40.3478261 22.3308837,40.3478261 C12.3286744,40.3478261 4.19134884,32.234087 4.19134884,22.2608696 L4.19134884,4.17391304 L40.4704186,4.17391304",
  id: "Fill-7",
  fill: "#D3AB05",
  mask: "url(#mask-6)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M31.9915116,14.1699826 L30.3701163,15.7873739 C30.3701163,15.7873739 29.2880233,16.3265043 28.2069767,15.2478957 C27.1248837,14.1699826 27.6659302,13.0913739 27.6659302,13.0913739 L29.2880233,11.4739826 C29.8294186,10.9348522 29.179186,10.4405913 28.6915116,10.4405913 C26.2956977,10.4405913 24.3540698,12.3765913 24.3540698,14.7647652 C24.3540698,15.101113 24.3966279,15.4259826 24.4688372,15.7404174 L20.8025581,19.3957217 L24.0463953,22.6305043 L27.7133721,18.9748522 C28.0283721,19.0472 28.354186,19.089287 28.6915116,19.089287 C31.0866279,19.089287 33.0282558,17.153287 33.0282558,14.7647652 C33.0282558,14.2753739 32.5322093,13.6305043 31.9915116,14.1699826",
  id: "Fill-38",
  fill: "#D3AB05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.1454651,29.2153391 C14.6612791,29.2153391 14.269186,28.8240348 14.269186,28.3412522 C14.269186,27.8584696 14.6612791,27.4668174 15.1454651,27.4668174 C15.63,27.4668174 16.022093,27.8584696 16.022093,28.3412522 C16.022093,28.8240348 15.63,29.2153391 15.1454651,29.2153391 L15.1454651,29.2153391 Z M20.7383721,19.5005565 L13.5303488,26.687687 C12.6453488,27.5701217 12.6453488,29.0000348 13.5303488,29.8821217 C14.415,30.7638609 15.8487209,30.7638609 16.7340698,29.8821217 L23.9413953,22.6949913 L20.7383721,19.5005565 Z",
  id: "Fill-40",
  fill: "#D3AB05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.169314,30.0653565 C29.8589651,30.7530087 30.9567558,30.7853565 31.6066395,30.1366609 C32.2572209,29.4879652 32.2244302,28.3940522 31.5351279,27.7064 L17.775593,13.9864 C17.0862907,13.2990957 15.9891977,13.2667478 15.3386163,13.9150957 C14.6880349,14.5641391 14.7204767,15.6577043 15.4101279,16.3453565 L29.169314,30.0653565 Z",
  id: "Fill-42",
  fill: "#AD8D07"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.618407,10.9670261 C23.618407,10.9670261 20.0700349,9.19798261 17.1129419,12.1465043 L12.9729419,16.2741565 C12.9729419,16.2741565 12.3816628,15.6845913 11.7900349,16.2741565 L11.1987558,16.8640696 C11.1987558,16.8640696 10.6074767,17.4536348 11.1987558,18.0432 L13.5645698,20.4021565 C13.5645698,20.4021565 14.1558488,20.9917217 14.7471279,20.4021565 L15.3387558,19.8125913 C15.3387558,19.8125913 15.9300349,19.2226783 15.3387558,18.633113 C15.3251512,18.6195478 15.3073605,18.6018087 15.2923605,18.5872 C15.7479419,18.1489391 16.4299186,17.7023304 17.1129419,18.0432 L19.478407,15.6845913 C19.478407,15.6845913 18.8871279,13.9155478 20.0700349,12.7360696 C21.2529419,11.5565913 21.8442209,11.5565913 23.0271279,11.5565913 C24.209686,11.5565913 23.618407,10.9670261 23.618407,10.9670261",
  id: "Fill-44",
  fill: "#D3AB05"
})))));

var SvgPowerBuilderGold = function SvgPowerBuilderGold(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPowerBuilderGold, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/power-builder-gold.28cff8ef.svg";
export { ForwardRef as ReactComponent };